var _defs, _path, _path2, _path3, _path4, _path5, _path6, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "102.25 214.52 185.25 160.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g10",
    x1: 137.82,
    y1: 264.13,
    x2: 252.18,
    y2: 264.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe8c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#f4db14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8a108"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g95",
    x1: 195,
    y1: 262.99,
    x2: 221.29,
    y2: 262.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8a108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b37808"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g44",
    x1: 195,
    y1: 259.84,
    x2: 221.29,
    y2: 259.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4ba14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8a108"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g95-2",
    x1: 0,
    y1: 276.57,
    x2: 211.25,
    y2: 276.57,
    xlinkHref: "#g95"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g44-2",
    x1: 0,
    y1: 276.57,
    x2: 211.25,
    y2: 276.57,
    xlinkHref: "#g44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g95-3",
    x1: 168.71,
    y1: 262.99,
    x2: 195,
    y2: 262.99,
    xlinkHref: "#g95"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g44-3",
    x1: 168.71,
    y1: 259.84,
    x2: 195,
    y2: 259.84,
    xlinkHref: "#g44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g95-4",
    x1: 186.77,
    y1: 251.57,
    x2: 195,
    y2: 251.57,
    xlinkHref: "#g95"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g44-4",
    x1: 0,
    y1: 251.57,
    x2: 203.22,
    y2: 251.57,
    xlinkHref: "#g44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g95-5",
    x1: 178.75,
    y1: 276.57,
    x2: 195,
    y2: 276.57,
    xlinkHref: "#g95"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g114",
    x1: 178.75,
    y1: 276.57,
    x2: 195,
    y2: 276.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b37808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9a6708"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g359",
    x1: 208.14,
    y1: 265.65,
    x2: 208.14,
    y2: 254.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffa2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#f4ea3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g95-6",
    x1: 203.12,
    y1: 287.49,
    x2: 203.12,
    y2: 265.65,
    xlinkHref: "#g95"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g304",
    x1: 203.12,
    y1: 265.65,
    x2: 203.12,
    y2: 287.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd12e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8a108"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g95-7",
    x1: 181.86,
    y1: 269.4,
    x2: 181.86,
    y2: 256.58,
    xlinkHref: "#g95"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g10-2",
    x1: 181.86,
    y1: 265.65,
    x2: 181.86,
    y2: 254.02,
    xlinkHref: "#g10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g95-8",
    x1: 186.77,
    y1: 251.57,
    x2: 195,
    y2: 251.57,
    xlinkHref: "#g95"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g168",
    x1: 199.11,
    y1: 265.65,
    x2: 199.11,
    y2: 237.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4ba14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g443",
    x1: 186.88,
    y1: 265.65,
    x2: 186.88,
    y2: 287.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd408"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b16808"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g509",
    x1: 178.75,
    y1: 276.57,
    x2: 195,
    y2: 276.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b5808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be7f08"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#eab200",
    d: "M145,307.36h0c-.02-1.95,1.22-3.71,3.08-4.31,1.68-.54,3.65-1.58,4.83-3.56,1.29-2.17,1.08-3.5.81-4.3-.45-1.34-1.95-3.54-6.51-6.35-4.19-2.59-9.7-4.92-14.02-6.66-5.89-2.37-11.75-5.71-16.5-9.39-5.98-4.64-10.16-9.7-12.42-15.03-1.19-2.82-1.84-5.7-1.91-8.57-.08-3.1.51-6.2,1.74-9.23,1.05-2.59,2.59-4.83,4.58-6.68,1.77-1.65,3.9-2.99,6.34-3.98,3.83-1.56,8.47-2.3,13.81-2.2,8.67.15,16.34,2.46,16.66,2.56,2.36.72,3.7,3.22,2.98,5.58-.72,2.36-3.21,3.7-5.58,2.98h0c-.07-.02-6.95-2.07-14.39-2.18-8.68-.12-14.1,2.33-16.12,7.3-1.49,3.66-1.45,7.24.12,10.94,3.75,8.86,15.29,16.1,24.02,19.61,4.66,1.87,10.62,4.4,15.39,7.35,5.55,3.43,8.91,7.06,10.28,11.1.64,1.9.83,3.87.56,5.86-.27,1.96-.99,3.93-2.15,5.88-2.29,3.86-6.02,6.27-9.72,7.51-2.87.96-5.85-1.18-5.88-4.21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#eab200",
    d: "M285.9,239.94c-1.05-2.59-2.59-4.83-4.58-6.68-1.77-1.65-3.9-2.99-6.34-3.98-3.83-1.56-8.47-2.3-13.81-2.2-8.67.15-16.34,2.46-16.66,2.56-2.36.72-3.7,3.22-2.98,5.58.72,2.36,3.22,3.7,5.58,2.98.07-.02,6.95-2.07,14.39-2.18,8.68-.12,14.1,2.33,16.12,7.3,1.49,3.66,1.45,7.24-.12,10.94-3.75,8.86-15.29,16.1-24.02,19.61-4.66,1.87-10.62,4.4-15.39,7.35-5.55,3.43-8.91,7.06-10.28,11.1-.64,1.9-.83,3.87-.56,5.86.27,1.96.99,3.93,2.15,5.88,2.31,3.88,6.03,6.28,9.71,7.51,2.88.96,5.85-1.19,5.87-4.23h0c.02-1.95-1.22-3.7-3.08-4.3-1.68-.54-3.64-1.58-4.81-3.56-1.29-2.17-1.08-3.5-.81-4.3.45-1.34,1.95-3.54,6.51-6.35,4.19-2.59,9.7-4.92,14.02-6.66,5.89-2.37,11.75-5.71,16.5-9.39,5.98-4.64,10.16-9.7,12.42-15.03,1.19-2.82,1.84-5.7,1.91-8.57.08-3.1-.51-6.2-1.74-9.23Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#efab00",
    d: "M207.06,362.64h-24.12c13.97-25.64,2.94-46.21.47-50.25-.29-.48-.47-.72-.47-.72h24.12s-.17.25-.47.72c-2.48,4.05-13.51,24.61.47,50.25Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g10)",
    d: "M252.18,219c0,.21-.02.43-.06.67-.95,5.21-7.7,44.81-17.03,64.87-7.29,15.68-15.87,24.67-28.5,27.85-3.53.89-7.37,1.32-11.59,1.32s-8.07-.43-11.59-1.32c-12.64-3.18-21.21-12.17-28.5-27.85-9.33-20.06-16.08-59.66-17.03-64.87-.04-.23-.06-.45-.06-.67,0-.03,0-.07,0-.1,0,0,0,0,0,0,0-.07,0-.13.02-.2,0-.09.02-.18.04-.27,0-.01,0-.02,0-.03,0-.02.01-.05.02-.07,0-.03.02-.06.02-.09,0-.03.02-.06.03-.09,0-.03.02-.06.03-.09,0,0,0,0,0,0,0-.03.02-.05.03-.08.01-.03.02-.06.04-.08.01-.03.03-.06.04-.08.04-.09.09-.17.14-.25.03-.05.06-.1.1-.15.02-.03.03-.05.05-.08.02-.02.04-.05.06-.07.02-.02.04-.05.06-.07.02-.02.04-.05.06-.07.02-.02.04-.05.06-.07.02-.02.04-.05.07-.07.02-.02.04-.05.07-.07.04-.04.09-.09.14-.13,0,0,0,0,0,0,.02-.02.05-.04.07-.06.12-.11.26-.21.39-.3.03-.02.06-.04.08-.06.03-.02.06-.04.09-.06.03-.02.06-.04.09-.05.03-.02.06-.04.09-.05.03-.02.06-.03.09-.05.03-.02.06-.03.09-.05.05-.03.11-.06.16-.09,0,0,.02,0,.02-.01.06-.03.13-.06.19-.09.1-.05.2-.09.3-.13.03-.01.07-.03.1-.04.03-.01.07-.03.1-.04.03-.01.07-.03.1-.04.14-.05.28-.1.42-.15.03-.01.07-.02.11-.04.04-.01.07-.02.11-.03.03,0,.06-.02.09-.03.03-.01.07-.02.1-.03.16-.05.32-.09.48-.13.03,0,.07-.02.1-.03.22-.06.45-.11.67-.16.03,0,.07-.01.1-.02.11-.02.23-.05.34-.07.06-.01.13-.02.19-.03.07-.01.15-.03.22-.04.03,0,.06-.01.09-.02.01,0,.02,0,.03,0,.11-.02.21-.03.32-.05.03,0,.06,0,.09-.01.03,0,.05,0,.08-.01.27-.04.53-.07.78-.09.04,0,.09,0,.13-.01.11-.01.21-.02.31-.03.08,0,.16-.01.24-.02.05,0,.09,0,.14-.01.05,0,.1,0,.14,0,.12,0,.23-.01.34-.02.03,0,.07,0,.1,0,.65-.03,1.05-.03,1.05-.03h94.72s.41,0,1.05.03c.03,0,.07,0,.1,0,.11,0,.22.01.34.02.05,0,.09,0,.14,0,.05,0,.09,0,.14.01.08,0,.16.01.24.02.1,0,.21.02.31.03.04,0,.08,0,.13.01.25.03.51.06.78.09.03,0,.05,0,.08.01.03,0,.06,0,.09.01.11.01.21.03.32.05.01,0,.02,0,.03,0,.03,0,.06.01.09.02.07.01.14.02.22.04.06.01.13.02.19.03.11.02.23.04.34.07.03,0,.07.01.1.02.23.05.45.1.67.16.03,0,.07.02.1.03.16.04.32.09.48.13.03.01.07.02.1.03.03,0,.06.02.09.03.04.01.07.02.11.03s.07.02.11.04c.14.05.28.1.42.15.03.01.07.03.1.04.03.01.07.03.1.04.03.01.07.03.1.04.1.04.2.09.3.13.07.03.13.06.19.09,0,0,.01,0,.02.01.06.03.11.06.16.09.03.02.06.03.09.05.03.02.06.03.09.05.03.02.06.04.09.05.03.02.06.04.09.05.03.02.06.04.09.06.03.02.06.04.08.06.14.09.27.19.39.3.02.02.05.04.07.06,0,0,0,0,0,0,.05.04.09.09.14.13.02.02.05.04.07.07.02.02.04.05.07.07.02.02.04.05.06.07.02.02.04.05.06.07.02.02.04.05.06.07.02.02.04.05.06.07.02.03.04.05.05.08.03.05.07.1.1.15.05.08.09.16.14.25.01.03.03.06.04.08.01.03.02.06.04.08.01.03.02.05.03.08,0,0,0,0,0,0,0,.03.02.06.03.09,0,.03.02.06.03.09,0,.03.02.06.02.09,0,.02.01.05.02.07,0,.01,0,.02,0,.03.02.09.03.18.04.27,0,.06.01.13.02.2,0,0,0,0,0,0,0,.03,0,.07,0,.1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#efab00",
    d: "M222.2,368.6h-54.41c0-3.29,2.67-5.97,5.97-5.97h42.48c1.65,0,3.14.67,4.22,1.75,1.08,1.08,1.75,2.57,1.75,4.22Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#efab00",
    d: "M230.88,371.62v2.95h-71.77v-2.95c0-1.67,1.35-3.02,3.02-3.02h65.73c1.67,0,3.02,1.35,3.02,3.02Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#g95)",
    points: "208.14 269.4 221.29 256.58 195 265.65 208.14 269.4"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#g44)",
    points: "203.22 254.02 221.29 256.58 195 265.65 203.22 254.02"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#g95-2)",
    points: "195 278.94 211.25 287.49 195 265.65 195 278.94"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#g44-2)",
    points: "208.14 269.4 211.25 287.49 195 265.65 208.14 269.4"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#g95-3)",
    points: "181.86 269.4 168.71 256.58 195 265.65 181.86 269.4"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#g44-3)",
    points: "186.77 254.02 168.71 256.58 195 265.65 186.77 254.02"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#g95-4)",
    points: "186.77 254.02 195 237.49 195 265.65 186.77 254.02"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#g44-4)",
    points: "203.22 254.02 195 237.49 195 265.65 203.22 254.02"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#g95-5)",
    points: "195 278.94 178.75 287.49 195 265.65 195 278.94"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#g114)",
    points: "181.86 269.4 178.75 287.49 195 265.65 181.86 269.4"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#g359)",
    points: "203.22 254.02 221.29 256.58 195 265.65 203.22 254.02",
    style: {
      mixBlendMode: "screen"
    }
  }), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#g95-6)",
    points: "195 278.94 211.25 287.49 195 265.65 195 278.94"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#g304)",
    points: "208.14 269.4 211.25 287.49 195 265.65 208.14 269.4"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#g95-7)",
    points: "181.86 269.4 168.71 256.58 195 265.65 181.86 269.4"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#g10-2)",
    points: "186.77 254.02 168.71 256.58 195 265.65 186.77 254.02"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#g95-8)",
    points: "186.77 254.02 195 237.49 195 265.65 186.77 254.02"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#g168)",
    points: "203.22 254.02 195 237.49 195 265.65 203.22 254.02",
    style: {
      mixBlendMode: "screen"
    }
  }), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#g443)",
    points: "195 278.94 178.75 287.49 195 265.65 195 278.94"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#g509)",
    points: "181.86 269.4 178.75 287.49 195 265.65 181.86 269.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyIcon);
export default __webpack_public_path__ + "static/media/trophy_icon.26ac26c9db9625972a2c45d9ec549c43.svg";
export { ForwardRef as ReactComponent };